module.exports = __webpack_public_path__ + "img/receipt-icon-rounded.0e9cff93.svg";